import script from "./CompleteModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompleteModal.vue?vue&type=script&setup=true&lang=ts"

import "./CompleteModal.vue?vue&type=style&index=0&id=3fd4e313&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd4e313"]])

export default __exports__